export class Storage {
	constructor() {
		this.site = window.englishName;
	}

	setItem(key, value) {
		return localforage.setItem(this.site + "_" + key, value);
	}

	getItem(key) {
		return localforage.getItem(this.site + "_" + key);
	}

	removeItem(key) {
		return localforage.removeItem(this.site + "_" + key);
	}
}
